
namespace Gamification.Gamification {
    export class ProdottiEsperienzeClassiColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzeClassi';
    }
}